import React, { useState, useRef, useEffect } from 'react';
import { IconButton, Stack, Box, Typography, Tooltip, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import './App.css';
import useStore from './Store';
import AppBar from './AppBar/AppBar';
import Drawer from './SideDrawer3';
import PropertiesList from './PropertiesList';
import MobileDrawer from './DrawerMobile';
import Map from './MapBox';

function Portfolio({ changeTheme, darkTheme }) {
  const {
    rightDrawer,
    toggleRightDrawer,
    project,
    portfolios,
    showViewer,
    toggleShowViewer
  } = useStore();
  const [showLoadingMessage, setShowLoadingMessage] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:600px)');
  const mapComponentRef = useRef();

  useEffect(() => {
    setShowLoadingMessage(true);

    const timer = setTimeout(() => {
      setShowLoadingMessage(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [project, showViewer]);

  const triggerGoToLocation = (lat, lang) => {
    mapComponentRef.current?.goToLocation(lat, lang);
  };

  return (
    <>
      <AppBar darkTheme={darkTheme} changeTheme={changeTheme} onGoToLocation={triggerGoToLocation} />

      {!isMobile && (
        <Drawer
          topPanelName='Overview'
          bottomPanelName='Details'
          projectName={portfolios[0].projects[project].name}
          topPanel={<PropertiesList />}
          bottomPanel={<PropertiesList />}
          topPanelButton={<IconButton aria-label="add property" size='small'><AddIcon fontSize='small' /></IconButton>}
          side='right'
          isOpen={rightDrawer}
          setIsOpen={toggleRightDrawer}
          showFirstPanel={true}
          showSecondPanel={false}
        />
      )}

      {isMobile && (
        <MobileDrawer
          panels={[<PropertiesList />]}
          projectName={portfolios[0].projects[project].name}
        />
      )}
      <Box
        sx={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Map ref={mapComponentRef} />
      </Box>
      {!isMobile &&
        <Stack
          direction="column"
          justifyContent="space-between"
          alignItems="center"
          sx={{position:'fixed', right: (rightDrawer && !isMobile) ? '400px' : '20px', top: '77px'}}
        >
              <Tooltip placement={'left'} title={'Information'}>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-haspopup="true"
                selected={rightDrawer}
                onClick={()=>toggleRightDrawer()}
              >
                <MenuOutlinedIcon size='inherit'/>
              </IconButton>
              </Tooltip>
        </Stack>
      }
      <Stack
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        sx={{position:'fixed', left: isMobile?'8px':'16px', top: '77px', height:isMobile?'73%':'82%'}}
      >
        <Tooltip placement={'left'} title={'3D model'}>
          <IconButton
            size="large"
            edge="end"
            aria-label="account of current user"
            aria-haspopup="true"
            onClick={()=>toggleShowViewer()}
          >
            <ViewInArIcon size='inherit'/>
          </IconButton>
        </Tooltip>
      </Stack>
      {showViewer && (
        <Stack
          id='viewer'
          justifyContent={'center'}
          alignItems={'center'}
          sx={isMobile?{
            position: 'absolute',
            top: 146,
            width: '100%'
          }:
          {
            position: 'absolute',
            top: 136,
            left: 14,
            width: 360,
            height: 360,
            borderRadius: '20px'
          }}
        >
          {showLoadingMessage && (
            <Typography
              variant='overline'
              sx={{ position: 'absolute', left: isMobile ?'40px':'20px', bottom: '120px', zIndex: 200 }}
            >
              Loading ...
            </Typography>
          )}
          <Stack
          spacing={1}
          sx={
            isMobile?
            { position: 'absolute', right: '30px', top: '18px' }:
            { position: 'absolute', right: '16px', top: '18px' }
            }>
          <IconButton
            size="small"
            edge="end"
            aria-label="close viewer"
            onClick={toggleShowViewer}
          >
            <CloseIcon fontSize='small' />
          </IconButton>
          <IconButton
            size="small"
            edge="end"
            aria-label="open model in new tab"
            onClick={() => window.open(portfolios[0].projects[project].modelUrl, '_blank', 'noopener, noreferrer')}
          >
            <OpenInNewIcon fontSize='small' />
          </IconButton>

          </Stack>

          <iframe
            title='model'
            style={{
              borderRadius: '10px',
              border: `1px solid ${theme.palette.primary.main}`,
              backgroundColor: theme.palette.background.default,
            }}
            src={portfolios[0].projects[project].modelUrl}
            width="360"
            height="360"
          >
            Your browser does not support iframes.
          </iframe>
        </Stack>
      )}
    </>
  );
}

export default Portfolio;
